"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _chart = _interopRequireDefault(require("chart.js"));
var _Page = _interopRequireDefault(require("@/ui/layout/Page"));
var _plantNursery = require("@/services/plant-nursery.service");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'ProductionDashboardPage',
  components: {
    Page: _Page.default
  },
  data: function data() {
    return {
      isLoading: false,
      charts: {
        statusDistribution: null,
        locationDistribution: null,
        nurseryTime: null,
        forecast: null
      },
      summary: {
        totalCurrent: 0,
        totalPrevious: 0,
        plantingBetweenCounts: 0,
        shippedBetweenCounts: 0,
        biopote: 0,
        sacolao: 0,
        readyToShip: 0
      },
      referenceDate: new Date(),
      productionDistribution: {
        status: []
      },
      varieties: [],
      locations: [],
      nurseryTime: {
        labels: [],
        datasets: {
          paraEnxertar: [],
          estaquia: [],
          enxertiaEmAtraso: [],
          enxertada: [],
          emBranco: []
        }
      },
      forecast: {
        labels: [],
        datasets: {
          enxertada: [],
          enxertiaEmAtraso: [],
          estaquia: [],
          paraEnxertar: []
        }
      },
      statusLegend: [{
        label: 'Enxertada',
        color: '#2ca02c'
      }, {
        label: 'Enxertia em atraso',
        color: '#d62728'
      }, {
        label: 'Estaquia',
        color: '#003f5c'
      }, {
        label: 'Para enxertar',
        color: '#ffcc00'
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    page: 'menuItemsPlantsNursery',
    farm: 'GET_FARM'
  })), {}, {
    totalVarieties: function totalVarieties() {
      return this.varieties.reduce(function (acc, v) {
        return acc + v.quantity;
      }, 0);
    },
    statusLegendWithoutBlank: function statusLegendWithoutBlank() {
      return this.statusLegend.filter(function (item) {
        return item.label !== '(Em branco)';
      });
    }
  }),
  methods: {
    fetchReports: function () {
      var _fetchReports = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$farm, _yield$plantNurserySe, data, report, _data$data$, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.isLoading = true;
              _context.p = 1;
              _context.n = 2;
              return _plantNursery.plantNurseryService.fetchLotsReports({
                farmId: (_this$farm = this.farm) === null || _this$farm === void 0 ? void 0 : _this$farm.id
              });
            case 2:
              _yield$plantNurserySe = _context.v;
              data = _yield$plantNurserySe.data;
              report = null;
              if (data) {
                if (Array.isArray(data.data)) {
                  report = (_data$data$ = data.data[0]) !== null && _data$data$ !== void 0 ? _data$data$ : null;
                } else if (data.data && _typeof(data.data) === 'object') {
                  report = data.data;
                } else {
                  report = data;
                }
              }
              if (report) {
                this.applyReports(report);
                this.$nextTick(this.buildCharts);
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.warn('Erro ao carregar relatórios de lotes', _t);
              // this.$buefy?.toast?.open?.({
              //   message: 'Não foi possível carregar os relatórios de lotes.',
              //   type: 'is-danger'
              // })
            case 4:
              _context.p = 4;
              this.isLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function fetchReports() {
        return _fetchReports.apply(this, arguments);
      }
      return fetchReports;
    }(),
    applyReports: function applyReports(report) {
      var _report$monthReports, _monthReports$totalPl, _monthReports$lastTot, _monthReports$totalDi, _report$totalDistribu, _totalDistribution$gr, _totalDistribution$gr2, _totalDistribution$gr3, _totalDistribution$gr4, _totalDistribution$cu, _totalDistribution$gr5, _totalDistribution$gr6, _report$varietyDistri, _report$varietyDistri2, _report$placeDistribu, _report$placeDistribu2, _report$distributionB, _report$forecastDistr;
      var monthReports = (_report$monthReports = report === null || report === void 0 ? void 0 : report.monthReports) !== null && _report$monthReports !== void 0 ? _report$monthReports : {};
      this.summary.totalCurrent = (_monthReports$totalPl = monthReports.totalPlants) !== null && _monthReports$totalPl !== void 0 ? _monthReports$totalPl : 0;
      this.summary.totalPrevious = (_monthReports$lastTot = monthReports.lastTotalPlants) !== null && _monthReports$lastTot !== void 0 ? _monthReports$lastTot : 0;
      this.summary.readyToShip = (_monthReports$totalDi = monthReports.totalDispatched) !== null && _monthReports$totalDi !== void 0 ? _monthReports$totalDi : 0;
      var totalDistribution = (_report$totalDistribu = report === null || report === void 0 ? void 0 : report.totalDistribution) !== null && _report$totalDistribu !== void 0 ? _report$totalDistribu : {};
      var distributionItems = [{
        label: 'Enxertada',
        value: (_totalDistribution$gr = (_totalDistribution$gr2 = totalDistribution.graftingLots) === null || _totalDistribution$gr2 === void 0 ? void 0 : _totalDistribution$gr2.plantingStage) !== null && _totalDistribution$gr !== void 0 ? _totalDistribution$gr : 0,
        color: '#2CA02C'
      }, {
        label: 'Enxertia em atraso',
        value: (_totalDistribution$gr3 = (_totalDistribution$gr4 = totalDistribution.graftingLots) === null || _totalDistribution$gr4 === void 0 ? void 0 : _totalDistribution$gr4.delayedGrafting) !== null && _totalDistribution$gr3 !== void 0 ? _totalDistribution$gr3 : 0,
        color: '#D62728'
      }, {
        label: 'Estaquia',
        value: (_totalDistribution$cu = totalDistribution.cuttingLots) !== null && _totalDistribution$cu !== void 0 ? _totalDistribution$cu : 0,
        color: '#1F77B4'
      }, {
        label: 'Para enxertar',
        value: (_totalDistribution$gr5 = (_totalDistribution$gr6 = totalDistribution.graftingLots) === null || _totalDistribution$gr6 === void 0 ? void 0 : _totalDistribution$gr6.graftingStage) !== null && _totalDistribution$gr5 !== void 0 ? _totalDistribution$gr5 : 0,
        color: '#FFCC00'
      }];
      var totalLots = distributionItems.reduce(function (acc, item) {
        return acc + (item.value || 0);
      }, 0);
      this.productionDistribution.status = distributionItems.map(function (item) {
        var _item$value;
        return _objectSpread(_objectSpread({}, item), {}, {
          percent: totalLots > 0 ? ((_item$value = item.value) !== null && _item$value !== void 0 ? _item$value : 0) / totalLots * 100 : 0
        });
      });
      this.varieties = (_report$varietyDistri = report === null || report === void 0 ? void 0 : (_report$varietyDistri2 = report.varietyDistribution) === null || _report$varietyDistri2 === void 0 ? void 0 : _report$varietyDistri2.map(function (v) {
        return {
          name: v.lotVariety || '—',
          quantity: v.quantity || 0
        };
      })) !== null && _report$varietyDistri !== void 0 ? _report$varietyDistri : [];
      this.locations = (_report$placeDistribu = report === null || report === void 0 ? void 0 : (_report$placeDistribu2 = report.placeDistribution) === null || _report$placeDistribu2 === void 0 ? void 0 : _report$placeDistribu2.map(function (p) {
        var _p$place, _p$place$sectionRow, _p$place$sectionRow$s, _p$place2, _p$place2$sectionRow, _ref, _p$place$quantity, _p$place3;
        var sectionName = (_p$place = p.place) === null || _p$place === void 0 ? void 0 : (_p$place$sectionRow = _p$place.sectionRow) === null || _p$place$sectionRow === void 0 ? void 0 : (_p$place$sectionRow$s = _p$place$sectionRow.section) === null || _p$place$sectionRow$s === void 0 ? void 0 : _p$place$sectionRow$s.name;
        var rowName = (_p$place2 = p.place) === null || _p$place2 === void 0 ? void 0 : (_p$place2$sectionRow = _p$place2.sectionRow) === null || _p$place2$sectionRow === void 0 ? void 0 : _p$place2$sectionRow.name;
        var label = [sectionName, rowName].filter(Boolean).join(' · ') || rowName || '—';
        var quantity = (_ref = (_p$place$quantity = (_p$place3 = p.place) === null || _p$place3 === void 0 ? void 0 : _p$place3.quantity) !== null && _p$place$quantity !== void 0 ? _p$place$quantity : p.quantity) !== null && _ref !== void 0 ? _ref : 0;
        return {
          label: label,
          value: quantity
        };
      })) !== null && _report$placeDistribu !== void 0 ? _report$placeDistribu : [];
      this.nurseryTime = this.buildTimeSeries((_report$distributionB = report === null || report === void 0 ? void 0 : report.distributionByMonth) !== null && _report$distributionB !== void 0 ? _report$distributionB : {});
      this.forecast = this.buildForecastSeries((_report$forecastDistr = report === null || report === void 0 ? void 0 : report.forecastDistributionByMonth) !== null && _report$forecastDistr !== void 0 ? _report$forecastDistr : {});
      this.referenceDate = new Date();
    },
    buildCharts: function buildCharts() {
      this.buildStatusDistributionChart();
      this.buildLocationDistributionChart();
      this.buildNurseryTimeChart();
      this.buildForecastChart();
    },
    buildTimeSeries: function buildTimeSeries(distByMonth) {
      var _this = this;
      var labels = [];
      var datasets = {
        paraEnxertar: [],
        estaquia: [],
        enxertiaEmAtraso: [],
        enxertada: [],
        emBranco: []
      };
      var months = Object.keys(distByMonth || {}).map(function (key) {
        return {
          key: key,
          date: _this.parseYearMonth(key)
        };
      }).sort(function (a, b) {
        return a.date - b.date;
      });
      months.forEach(function (_ref2) {
        var _dist$graftingLots$gr, _dist$graftingLots, _dist$graftingLots$de, _dist$graftingLots2, _dist$cuttingLots, _dist$graftingLots$pl, _dist$graftingLots3;
        var key = _ref2.key,
          date = _ref2.date;
        labels.push(_this.monthLabel(date));
        var dist = distByMonth[key] || {};
        datasets.enxertada.push((_dist$graftingLots$gr = (_dist$graftingLots = dist.graftingLots) === null || _dist$graftingLots === void 0 ? void 0 : _dist$graftingLots.graftingStage) !== null && _dist$graftingLots$gr !== void 0 ? _dist$graftingLots$gr : 0);
        datasets.enxertiaEmAtraso.push((_dist$graftingLots$de = (_dist$graftingLots2 = dist.graftingLots) === null || _dist$graftingLots2 === void 0 ? void 0 : _dist$graftingLots2.delayedGrafting) !== null && _dist$graftingLots$de !== void 0 ? _dist$graftingLots$de : 0);
        datasets.estaquia.push((_dist$cuttingLots = dist.cuttingLots) !== null && _dist$cuttingLots !== void 0 ? _dist$cuttingLots : 0);
        datasets.paraEnxertar.push((_dist$graftingLots$pl = (_dist$graftingLots3 = dist.graftingLots) === null || _dist$graftingLots3 === void 0 ? void 0 : _dist$graftingLots3.plantingStage) !== null && _dist$graftingLots$pl !== void 0 ? _dist$graftingLots$pl : 0);
        datasets.emBranco.push(0);
      });
      return {
        labels: labels,
        datasets: datasets
      };
    },
    buildForecastSeries: function buildForecastSeries(forecastByMonth) {
      var _this2 = this;
      var labels = [];
      var datasets = {
        enxertada: [],
        enxertiaEmAtraso: [],
        estaquia: [],
        paraEnxertar: []
      };
      var months = Object.keys(forecastByMonth || {}).map(function (key) {
        return {
          key: key,
          date: _this2.parseYearMonth(key)
        };
      }).sort(function (a, b) {
        return a.date - b.date;
      });
      months.forEach(function (_ref3) {
        var _dist$graftingLots$gr2, _dist$graftingLots4, _dist$graftingLots$de2, _dist$graftingLots5, _dist$cuttingLots2, _dist$graftingLots$pl2, _dist$graftingLots6;
        var key = _ref3.key,
          date = _ref3.date;
        labels.push(_this2.monthLabel(date));
        var dist = forecastByMonth[key] || {};
        datasets.enxertada.push((_dist$graftingLots$gr2 = (_dist$graftingLots4 = dist.graftingLots) === null || _dist$graftingLots4 === void 0 ? void 0 : _dist$graftingLots4.graftingStage) !== null && _dist$graftingLots$gr2 !== void 0 ? _dist$graftingLots$gr2 : 0);
        datasets.enxertiaEmAtraso.push((_dist$graftingLots$de2 = (_dist$graftingLots5 = dist.graftingLots) === null || _dist$graftingLots5 === void 0 ? void 0 : _dist$graftingLots5.delayedGrafting) !== null && _dist$graftingLots$de2 !== void 0 ? _dist$graftingLots$de2 : 0);
        datasets.estaquia.push((_dist$cuttingLots2 = dist.cuttingLots) !== null && _dist$cuttingLots2 !== void 0 ? _dist$cuttingLots2 : 0);
        datasets.paraEnxertar.push((_dist$graftingLots$pl2 = (_dist$graftingLots6 = dist.graftingLots) === null || _dist$graftingLots6 === void 0 ? void 0 : _dist$graftingLots6.plantingStage) !== null && _dist$graftingLots$pl2 !== void 0 ? _dist$graftingLots$pl2 : 0);
      });
      return {
        labels: labels,
        datasets: datasets
      };
    },
    monthLabel: function monthLabel(date) {
      var _date$getTime;
      if (!date || Number.isNaN((_date$getTime = date.getTime) === null || _date$getTime === void 0 ? void 0 : _date$getTime.call(date))) return '—';
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var year = date.getFullYear();
      return "".concat(month, "/").concat(year);
    },
    parseYearMonth: function parseYearMonth(value) {
      if (!value) return new Date(NaN);
      // Parse YYYY-MM-DD format
      var parts = String(value).split('-').map(function (v) {
        return Number(v);
      });
      var _parts = _slicedToArray(parts, 3),
        year = _parts[0],
        month = _parts[1],
        day = _parts[2];
      if (!Number.isFinite(year) || !Number.isFinite(month)) return new Date(NaN);
      return new Date(year, month - 1, day || 1);
    },
    formatReferenceDate: function formatReferenceDate(date) {
      if (!date) return '—';
      var d = new Date(date);
      return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString('pt-BR');
    },
    buildStatusDistributionChart: function buildStatusDistributionChart() {
      var ctx = this.$refs.statusDistributionChart;
      if (!ctx) return;
      if (this.charts.statusDistribution) this.charts.statusDistribution.destroy();
      this.charts.statusDistribution = new _chart.default(ctx, {
        type: 'doughnut',
        data: {
          labels: this.productionDistribution.status.map(function (s) {
            return s.label;
          }),
          datasets: [{
            data: this.productionDistribution.status.map(function (s) {
              return s.value;
            }),
            backgroundColor: this.productionDistribution.status.map(function (s) {
              return s.color;
            }),
            borderWidth: 0
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutoutPercentage: 70,
          legend: {
            display: false
          },
          tooltips: {
            callbacks: {
              label: function label(tooltipItem, data) {
                var label = data.labels[tooltipItem.index];
                var value = data.datasets[0].data[tooltipItem.index];
                return "".concat(label, ": ").concat(value.toLocaleString('pt-BR'), " mudas");
              }
            }
          }
        }
      });
    },
    buildLocationDistributionChart: function buildLocationDistributionChart() {
      var ctx = this.$refs.locationDistributionChart;
      if (!ctx) return;
      if (this.charts.locationDistribution) this.charts.locationDistribution.destroy();
      this.charts.locationDistribution = new _chart.default(ctx, {
        type: 'bar',
        data: {
          labels: this.locations.map(function (l) {
            return l.label;
          }),
          datasets: [{
            label: 'Quantidade de mudas',
            data: this.locations.map(function (l) {
              return l.value;
            }),
            backgroundColor: '#808080',
            barThickness: 40
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                callback: function callback(value) {
                  return "".concat((value / 1000).toFixed(0), " Mil");
                }
              }
            }]
          }
        }
      });
    },
    buildNurseryTimeChart: function buildNurseryTimeChart() {
      var ctx = this.$refs.nurseryTimeChart;
      if (!ctx) return;
      if (this.charts.nurseryTime) this.charts.nurseryTime.destroy();
      var colors = {
        paraEnxertar: '#ffcc00',
        estaquia: '#003f5c',
        enxertiaEmAtraso: '#d62728',
        enxertada: '#2ca02c',
        emBranco: '#1f77b4'
      };
      this.charts.nurseryTime = new _chart.default(ctx, {
        type: 'bar',
        data: {
          labels: this.nurseryTime.labels,
          datasets: [{
            label: 'Para enxertar',
            data: this.nurseryTime.datasets.paraEnxertar,
            backgroundColor: colors.paraEnxertar,
            barThickness: 40
          }, {
            label: 'Estaquia',
            data: this.nurseryTime.datasets.estaquia,
            backgroundColor: colors.estaquia,
            barThickness: 40
          }, {
            label: 'Enxertia em atraso',
            data: this.nurseryTime.datasets.enxertiaEmAtraso,
            backgroundColor: colors.enxertiaEmAtraso,
            barThickness: 40
          }, {
            label: 'Enxertada',
            data: this.nurseryTime.datasets.enxertada,
            backgroundColor: colors.enxertada,
            barThickness: 40
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              stacked: true
            }],
            yAxes: [{
              stacked: true,
              ticks: {
                beginAtZero: true,
                callback: function callback(value) {
                  return "".concat((value / 1000).toFixed(1), " Mil");
                }
              }
            }]
          }
        }
      });
    },
    buildForecastChart: function buildForecastChart() {
      var ctx = this.$refs.forecastChart;
      if (!ctx) return;
      if (this.charts.forecast) this.charts.forecast.destroy();
      this.charts.forecast = new _chart.default(ctx, {
        type: 'bar',
        data: {
          labels: this.forecast.labels,
          datasets: [{
            label: 'Enxertada',
            data: this.forecast.datasets.enxertada,
            backgroundColor: '#2ca02c',
            barThickness: 40
          }, {
            label: 'Enxertia em atraso',
            data: this.forecast.datasets.enxertiaEmAtraso,
            backgroundColor: '#d62728',
            barThickness: 40
          }, {
            label: 'Estaquia',
            data: this.forecast.datasets.estaquia,
            backgroundColor: '#003f5c',
            barThickness: 40
          }, {
            label: 'Para enxertar',
            data: this.forecast.datasets.paraEnxertar,
            backgroundColor: '#ffcc00',
            barThickness: 40
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              stacked: true
            }],
            yAxes: [{
              stacked: true,
              ticks: {
                beginAtZero: true,
                callback: function callback(value) {
                  return "".concat((value / 1000).toFixed(1), " Mi");
                }
              }
            }]
          }
        }
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;
    this.fetchReports().then(function () {
      if (!_this3.charts.statusDistribution) {
        _this3.$nextTick(_this3.buildCharts);
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    var _this4 = this;
    Object.keys(this.charts).forEach(function (key) {
      if (_this4.charts[key]) _this4.charts[key].destroy();
    });
  }
};